import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import MainPage from './features/MainPage';
import dayjs from 'dayjs';
import viVN from 'antd/locale/vi_VN';
import 'dayjs/locale/vi'; 
import { ConfigProvider } from 'antd'; 
dayjs.locale('vi');

function App() {
  return (
    <div className="App">
      <ConfigProvider locale={viVN}>
        <Router>
          <MainPage />
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
